import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CustomerAddress,
  CustomerDetails,
  CustomerProfile
} from 'api/user/customer_requests';

const initialState: CustomerDetails | null = {
  fullName: '',
  email: '',
  dob: null,
  gender: '',
  phone: '',
  alternatePhone: '',
  shippingAddress: {
    street: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    phone: ''
  },
  billingAddress: {
    street: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    phone: ''
  },
  totalOrders: 0,
  totalSpent: 0,
  lastOrderDate: null,
  createdAt: null
};

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerDetails: (state, action: PayloadAction<CustomerDetails>) => {
      return action.payload;
    },
    updateProfileDetails: (state, action: PayloadAction<CustomerProfile>) => {
      state.dob = action.payload.dob;
      state.gender = action.payload.gender;
      state.phone = action.payload.phone;
      state.alternatePhone = action.payload.alternatePhone ?? '';
    },
    updateShippingAddress: (state, action: PayloadAction<CustomerAddress>) => {
      state.shippingAddress = action.payload;
    },
    updateBillingAddress: (state, action: PayloadAction<CustomerAddress>) => {
      state.billingAddress = action.payload;
    },
    updateTotalOrders: (state, action: PayloadAction<number>) => {
      state.totalOrders = action.payload;
    },
    updateTotalSpent: (state, action: PayloadAction<number>) => {
      state.totalSpent = action.payload;
    },
    updateLastOrderDate: (state, action: PayloadAction<Date>) => {
      state.lastOrderDate = action.payload;
    }
  }
});

export const {
  setCustomerDetails,
  updateProfileDetails,
  updateShippingAddress,
  updateBillingAddress,
  updateTotalOrders,
  updateTotalSpent,
  updateLastOrderDate
} = customerSlice.actions;
export default customerSlice.reducer;
